module.exports = __webpack_public_path__ + "static/img/black-logo.09c440a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/black-logo.svg
// module id = N9x9
// module chunks = 38